import { Iterable, IAddable } from "../Utils/ObjUtils";
import { ObjectSerializer } from "./ObjectSerializer";
import { ValueEncoder } from "../Utils/ValueEncoder";
import { Guid } from "../Utils/Guid";


export interface ElemWriter<T> {
	(value: T): any;
}

export interface ElemReader<T> {
	(value: any): T;
}

export class ObjSerUtils {

	public static WriteCollection<T>(arr: Array<any>, coll: Iterable<T>, elemWriter: ElemWriter<T>, context: any): void {

		coll.ForEach((value: T) => {
			let elem = elemWriter(value);
			arr.push(elem);
		});
	}

	public static ReadCollection<T>(arr: Array<any>, coll: IAddable<T>,
		elemReader: ElemReader<T>, context: any): void {

		arr.forEach((value: any) => {
			let elem = elemReader(value);
			coll.Add(elem);
		});
	}

	public static WriteObjSerCollection<T extends ObjectSerializer>(arr: Array<any>, coll: Iterable<T>, context: any): void {

		ObjSerUtils.WriteCollection(arr, coll, (value: T) => {
			let elem = {};
			value.Write(elem, context);
			return elem;
		}, context);
	}

	public static ReadObjSerCollection<T extends ObjectSerializer>(arr: Array<any>, coll: IAddable<T>,
		elemFactory: (value: any) => T, context: any): void {

		ObjSerUtils.ReadCollection(arr, coll, (value: any) => {
			let elem = elemFactory(value);
			elem.Read(value, context);
			return elem;
		}, context);
	}

	public static WriteStringCollection(arr: Array<any>, coll: Iterable<string>, elemWrapperName: string, context: any): void {

		ObjSerUtils.WriteCollection(arr, coll, (value: string) => {
			let elem = {};
			elem[elemWrapperName] = value;
			return elem;
		}, context);
	}

	public static ReadStringCollection(arr: Array<any>, coll: IAddable<string>, elemWrapperName: string, context: any): void {

		ObjSerUtils.ReadCollection(arr, coll, (value: any) => {
			let elem: string = value[elemWrapperName];
			return elem;
		}, context);
	}

	public static WriteNumberCollection(arr: Array<any>, coll: Iterable<number>, elemWrapperName: string, context: any): void {

		ObjSerUtils.WriteCollection(arr, coll, (value: number) => {
			let elem = {};
			elem[elemWrapperName] = value;
			return elem;
		}, context);
	}

	public static ReadNumberCollection(arr: Array<any>, coll: IAddable<number>, elemWrapperName: string, context: any): void {

		ObjSerUtils.ReadCollection(arr, coll, (value: any) => {
			let elem: number = value[elemWrapperName];
			return elem;
		}, context);
	}

	public static WriteStringValueCollection(arr: Array<any>, coll: Iterable<string>, context: any): void {

		ObjSerUtils.WriteStringCollection(arr, coll, "value", context);
	}

	public static ReadStringValueCollection(arr: Array<any>, coll: IAddable<string>, context: any): void {

		ObjSerUtils.ReadStringCollection(arr, coll, "value", context);
	}

	public static WriteStringEntryCollection(arr: Array<any>, coll: Iterable<string>, context: any): void {

		ObjSerUtils.WriteStringCollection(arr, coll, "entry", context);
	}

	public static ReadStringEntryCollection(arr: Array<any>, coll: IAddable<string>, context: any): void {

		ObjSerUtils.ReadStringCollection(arr, coll, "entry", context);
	}

	public static WriteNumberEntryCollection(arr: Array<any>, coll: Iterable<number>, context: any): void {

		ObjSerUtils.WriteNumberCollection(arr, coll, "entry", context);
	}

	public static ReadNumberEntryCollection(arr: Array<any>, coll: IAddable<number>, context: any): void {

		ObjSerUtils.ReadNumberCollection(arr, coll, "entry", context);
	}

	public static WriteGuidCollection(arr: Array<any>, coll: Iterable<Guid>, elemWrapperName: string, context: any): void {

		ObjSerUtils.WriteCollection(arr, coll, (value: Guid) => {
			let elem = {};
			elem[elemWrapperName] = ValueEncoder.EncodeGuid(value);
			return elem;
		}, context);
	}

	public static ReadGuidCollection(arr: Array<any>, coll: IAddable<Guid>, elemWrapperName: string, context: any): void {

		ObjSerUtils.ReadCollection(arr, coll, (value: any) => {
			let elem: Guid = ValueEncoder.DecodeGuid(value[elemWrapperName]);
			return elem;
		}, context);
	}

	public static Copy(orig: ObjectSerializer, copy: ObjectSerializer, context: Object = null): void {
		if (!context)
			context = {};
		let obj = {};
		orig.Write(obj, context);
		copy.Read(obj, context);
	}

}

